import React from "react";
import Footer from "../../Components/Footer";
import Header from "../../Components/Header";
import { Scrollbars } from "react-custom-scrollbars";
import "./NftDetails.scss";
import Api from "../../Common/api.jsx";
import { ethers } from "ethers";
import Web3Modal from "web3modal";
import NFTMarket from "../../../artifacts/contracts/NFTMarket.sol/NFTMarket.json";
import { Navigate, Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { notifications } from "../../Helpers/Notifications";
import ErrorHandler from "../../Helpers/ErrorHandler.jsx";
import MetaMaskService from "../../Common/metamaskService.jsx";
import CommonHelper from "../../Helpers/CommonHelper.jsx";
import DateHelper from "../../Helpers/DateHelper.jsx";
import { InlineShareButtons } from "sharethis-reactjs";
import SkeletonProduct ,{Row} from "../../Pages/Skeleton/index.jsx";

export default class NftDetails extends React.Component {
  constructor(props) {
    super(props);
    this.timeout = 0;
    this.state = {
      loader: false,
      loader1: false,
      loader2: false,
      assetDetails: {},
      assetActivity: [],
      id: null,
      condition: false,
      navigateToUserProfile: "",
      navigateToList: "",
      relatedAssets: [],
      marketItem: null,
      account: null,
      isListItem: false,

      redirect: null,
      chainConfig: null,
      showSwitchNetworkPopup: false,
      isBuying: false,
      showM: false,
      isOwnAccount: false,
      account: "",
      cartList:[],
      addToCartButton:true,
      sameAccount:false
     
    };
  }

  async componentDidMount() {
    localStorage.removeItem("cartUrl");
    window.scrollTo(0, 0);
    window.addEventListener("click", () => {
      if (document.getElementsByClassName("search-autocomplete")) {
        document.getElementsByClassName(
          "search-autocomplete"
        )[0].style.display = "none";
      }
    });

    this.initFunction();
  }

  initFunction() {
    const search = window.location.search;
    console.log(window.location.href);
    const params = new URLSearchParams(search);

    this.setState(
      {
        id: params.get("assetId"),
        navigateToList: "/nftList/?assetId=" + params.get("assetId"),
      },
      async () => {
        await this.getAccount();
        this.getAsset();
        this.getAssetActivity();
        this.getRelatedAssets();
      }
    );
    console.log(this.state.id);
  }
  // onClickNft(asset_id) {
  //   this.setState(
  //     { id: asset_id, redirect: "../NftDetails/?assetId=" + asset_id },
  //     () => {
  //       this.getAccount();
  //       this.getAsset();
  //       this.getAssetActivity();
  //       this.getRelatedAssets();
  //     }
  //   );
  // }

  scrollToTestDiv() {
    const divElement = document.getElementById("test");
    divElement.scrollIntoView({ behavior: "smooth" });
  }

  async getAsset() {
    const api = new Api();
    this.setState({ loader1: true });

    api
      .get("get_asset/?asset_id=" + this.state.id, {})
      .then((response) => {
        console.log("Asset", response.data);
        const chainConfig = new CommonHelper().getChainConfig(
          response.data.chain_id
        );
        console.log(response.data.chain_id,chainConfig)
        this.checkInCart(this.state.id);
        this.setState({
          assetDetails: response.data,
          chainConfig: chainConfig,
        });
        let accountloc = localStorage.getItem("accountId");
        if (accountloc) {
          if (
            this.state.account?.toLocaleLowerCase() ===
            accountloc.toLocaleLowerCase()
          ) {
            this.setState({ isOwnAccount: true });
            this.setState({ loader1: false });
          }
          this.setState({ loader1: false });
        } else {
          this.checkLoginAccount();
          this.setState({ loader1: false });
        }
        this.checkAssetAndLogAccount(response.data.owner_account,this.state.account);
      })
      .catch((err) => console.log(err));
  }

  async checkLoginAccount() {
    let loggedInAccount = await new MetaMaskService().getAccount();
    if (
      this.state.account.toLocaleLowerCase() ===
      loggedInAccount.toLocaleLowerCase()
    ) {
      this.setState({ isOwnAccount: true });
    }
  }

  getAssetActivity() {
    const api = new Api();
    this.setState({ loader2: true });
    api
      .get("get_asset_activity/?asset_id=" + this.state.id, {})
      .then((response) => {
        this.setState({ assetActivity: response.data });
        this.setState({ loader2: false });
      })
      .catch((err) => console.log(err));
  }

  async getAccount() {
    let account = await new MetaMaskService().getAccount();

    this.setState({
      navigateToUserProfile: "/userprofile/?account=" + account,
      account: account,
    });
    this.getCartList(account);
    return account;
  }
  checkAssetAndLogAccount(logAc,assetAc){
    /*if ( logAc?.toLocaleLowerCase() === assetAc.toLocaleLowerCase() ) {
      this.setState({ sameAccount: true });
    }else{
      this.setState({ sameAccount: false });
    }*/
    this.setState({ addToCartButton: true });
  }
  onhover() {
    this.setState({ showM: true });
    console.log(this.state.showM);
  }

  async getContract() {
    const web3Modal = new Web3Modal();
    const connection = await web3Modal.connect();
    const provider = new ethers.providers.Web3Provider(connection);
    const signer = provider.getSigner();
    const contract = new ethers.Contract(
      this.state.chainConfig.NFT_MARKETPLACE_ADDRESS,
      NFTMarket.abi,
      signer
    );

    return contract;
  }

  async buyNft(event) {
    event.preventDefault();

    if (window.ethereum.networkVersion !== this.state.chainConfig.CHAIN_ID) {
      this.setState({ showSwitchNetworkPopup: true });

      return;
    }

    try {
      this.setState({ isBuying: true });
      var contract = await this.getContract();
      const price = ethers.utils.parseUnits(
        this.state.assetDetails.price.toString(),
        "ether"
      );

      // /* user will be prompted to pay the asking process to complete the transaction */
      await contract
        .createMarketSale(this.state.assetDetails.token_id, {
          value: price,
        })
        .then(
          async (transactionDetails) => {
            var tx = await transactionDetails.wait();
            // console.log(" transaction", receipt);
            var asset_activity = {
              from_account: this.state.assetDetails.owner_account,
              to_account: this.state.account,
              price: this.state.assetDetails.price,
              asset_id: this.state.assetDetails.asset_id,
              currency: this.state.chainConfig.CURRENCY_SYMBOL,
              activity_type_id: 3,
              transaction_hash: tx.transactionHash,
            };

            await new Api().post("create_activity/", asset_activity);

            notifications.success("Order executed successfully");
            this.setState({ condition: true });
          },
          (err) => {
            console.log("error", err);
            this.setState({ isBuying: false });
            new ErrorHandler().processEtherMessage(err);
          }
        );
    } catch (err) {
      notifications.error("Something went wrong.");
      this.setState({ isBuying: false });
    }
  }

  listNft(event) {
    event.preventDefault();
    this.setState({ isListItem: true });
  }

  async addToCart(assetId){
    if(this.state.account){
      if(this.state.cartList.length >0){
        console.log(this.state.cartList[0].chain_id+"", this.state.assetDetails.chain_id+"");
        if (this.state.cartList[0].chain_id+"" !== this.state.assetDetails.chain_id+"") {
          notifications.error("Items from different chains can't be purchased together");
          return;
        }
      }

      var chain_id= this.state.assetDetails.chain_id
      if(this.state.cartList.length == 0){
        chain_id = this.state.assetDetails.chain_id
      }else{
        chain_id = this.state.cartList[0].chain_id
      }
      const chainConfig = await new CommonHelper().getChainConfig(
        chain_id
      );
      this.setState({ chainConfig: chainConfig });
      if (window.ethereum.networkVersion !== this.state.chainConfig.CHAIN_ID) {
        this.setState({ showSwitchNetworkPopup: true });
        return;
      }

      var body = {
        asset_id: this.state.assetDetails.asset_id,
        currency_name: this.state.chainConfig.CURRENCY_SYMBOL,
        price: this.state.assetDetails.price+"",
        chain_id:this.state.assetDetails.chain_id,
        collection_id:this.state.assetDetails.collection_id,
        usd_amount:this.state.assetDetails.usd_amount,
        account: this.state.account,
        owner_account: this.state.assetDetails.owner_account,
      };
      new Api().post("add_to_cart/", body).then((response) => {
        this.getCartList(this.state.account);
        this.setState({addToCartButton : false})
        this.checkInCart(assetId);
        //this.props.updateCartList();
        notifications.success("Added to cart successfully");
      }).catch((err) =>{
        notifications.error("Something went wrong..");
      console.log(err)
      });
    }else{
      localStorage.setItem("cartUrl",window.location.pathname+window.location.search);
      this.setState({redirect : '/Login'})
    }
    
  }

  getCartList(account){
    if(account){
      new Api().get("get_user_cart/?account="+account ).then((response) => {
        this.setState({ cartList: response.data });
      }).catch((err) => console.log(err));
    }
  }
  checkInCart(assetId){
    this.state.cartList.map((item) => {
        if(assetId == item.asset_id){
          this.setState({addToCartButton : false})
        }
    });
  }

  getCartId(assetId){
    var cart_id= null
    this.state.cartList.map((item) =>{
      console.log(item.asset_id == assetId);
      if(item.asset_id == assetId){
        cart_id= item.cart_id 
      }
    });
    return cart_id;
  }
  removeCart(){
    var cartId = this.getCartId(this.state.assetDetails.asset_id)
    console.log(cartId);
    let cartIds = []
    if(cartId == 'All'){
        this.state.cartList.map((id)=>{
          cartIds.push(id+"");
        });
    }else{
      cartIds.push(cartId+"");
    }
    var body = {
      cartId: cartIds,
      account: this.state.account,
    };
     new Api().post("remove_cart_item/", body).then((response) => {
      this.getCartList(this.state.account);
      this.setState({addToCartButton : true})
      notifications.success("Removed From Cart successfully");
    }).catch((err) =>{
      notifications.error("Something went wrong..");
     console.log(err)
    });
  }

  getRelatedAssets() {
    const api = new Api();
    this.setState({ loader: true });

    // if (this.timeout) clearTimeout(this.timeout);
    // this.timeout = setTimeout(() => {
    api
      .get("get_related_assets/?asset_id=" + this.state.id, {})
      .then((response) => {
        this.setState({ relatedAssets: response.data });
        this.setState({ loader: false });
      })
      .catch((err) => console.log(err));
    //}, 0);
  }

  async getMarketItem() {
    var contract = await this.getContract();

    return await contract.getMarketItemByTokenId(
      this.state.assetDetails.token_id
    );
  }

  getFormattedDateTime(date) {
    if (date) return new DateHelper().getFormattedDateTime(date);

    return "";
  }

  getIcon(event_type) {
    return new CommonHelper().getIcon(event_type);
  }

  getTransactionLink(transaction_hash) {
    return this.state.chainConfig
      ? `${this.state.chainConfig.BLOCK_EXPLORER_URL}/tx/${transaction_hash}`
      : "";
  }

  getMarketAddress() {
    return this.state.chainConfig
      ? `${this.state.chainConfig?.BLOCK_EXPLORER_URL}/address/${this.state.chainConfig?.NFT_MARKETPLACE_ADDRESS}`
      : "";
  }
  

  showMore() {
    this.getRelatedAssets();
  }

  render = () => {
    const { condition, isListItem } = this.state;

    if (condition) {
      return <Navigate to={this.state.navigateToUserProfile} />;
    }

    if (isListItem) {
      return <Navigate to={this.state.navigateToList} />;
    }
    if (this.state.redirect) {
      var url = this.state.redirect;
      this.setState({ redirect: null });
      return (
        <Navigate
          // to={"../SearchResult/?tab=Asset&search=" + this.state.value}
          to={url}
          replace={true}
        />
      );
    }
    return (
      <>
        <ToastContainer closeOnClick pauseOnFocusLoss draggable pauseOnHover />

        <Header
          showSwitchNetworkPopup={this.state.showSwitchNetworkPopup}
          network={this.state.chainConfig?.NETWORK_NAME}
          chainId={this.state.chainConfig?.CHAIN_HEX_ID}
          onPopupClose={() => {
            this.setState({ showSwitchNetworkPopup: false });
          }}
          hideCartButton={() =>{
            this.getAsset();
          }}
          //updateCartList ={this.props.updateCartList()}
        />

        {/* <div className="funds-with-card-popup">
          <div className="funds-with-card-popup__aside">
            <button className="btn-close" onClick={() => { this.closePopup(true); }} >
              <img src="../images/svg/btn-popup-close.svg" alt="close" />
            </button> 
            <h3><a href="#"><img src="../images/svg/left-arrow.svg" alt="close" /></a> Add Funds With Card</h3>
            <div className="frame-box">
              <h3 className="black">Third party iframe goes here</h3>
            </div> 
            <p>Powered by XYZ company</p> 
          </div>
        </div> */}
        {/* <div className="funds-popup" style={{display:'block'}}>
          <div className="funds-popup__aside">
          <button className="btn-close" onClick={() => { this.closePopup(true); }} >
            <img src="../images/svg/btn-popup-close.svg" alt="close" />
          </button> 
            <h2>ADD FUNDS</h2>
            <h5>You need 3.459 ETH + <strong>gas fees</strong> </h5>
            <p>Transfer funds to your wallet or add funds with card to complete this purchase. It can up to a minute for your balance to update.</p>
            <ul className="fund-list">
            <li>
                <a href="#">
                <div className="left">
                    <i><img src="../images/ethereum.png" alt="" /></i>
                    <h4>0x6D798B...43f0</h4>
                    <p>Ethereum</p>
                  </div>
                  <div className="right"> 
                    <h4>1.115 ETH</h4>
                    <p>Balance</p>
                  </div>
                </a>
              </li>
              <li>
                <a href="#">
                  <div className="left">
                    <i><img src="../images/ethereum.png" alt="" /></i>
                    <h4>0x6D798B...43f0</h4>
                    <p>Ethereum</p>
                  </div>
                  <div className="right"> 
                    <h4>1.115 ETH</h4>
                    <p>Balance</p>
                  </div>
                </a>
              </li>
            </ul>
            <button className="button">Continue</button>
            <button className="button button__text">Add funds with card</button>
          </div>
        </div> */}

        <div className="nft-details">
          <div className="container" id="test">
            <div className="nft-details__img">
              {!this.state.loader1 ? (
                <img
                  src={this.state.assetDetails.asset_image}
                  alt="profileimage"
                />
              ) : (
                [1].map((loading) => (
                  <>
                    <div className="skeleton-items" key={loading}>
                      <SkeletonProduct />
                    </div>
                  </>
                ))
              )}
            </div>
            <div className="nft-details__info">
              <div className="nft-details__info-header">
                <div class="leftDiv">
                  <Link
                    className="collectionLink_link"
                    to={
                      "/CollectionDetails/?collectionId=" +
                      this.state.assetDetails.collection_id
                    }
                  >
                    <div className="collectionLink_title">
                      {" "}
                      {this.state.assetDetails.collection_name}
                    </div>
                  </Link>
                </div>
                <div class="rightDiv">
                  {" "}
                  {this.state.assetDetails.status === "List" ? (
                    this.state.isBuying ? (
                      <div className="button btn-waiting ">
                        <img
                          className="loader"
                          src="../Loader/redshilliz-loader.gif "
                          alt="Coin"
                        />
                        Buying...
                      </div>
                    ) : (
                      <button
                        href=""
                        className="button"
                        onClick={(event) => this.buyNft(event)}
                      >
                        Buy Now
                      </button>
                    )
                  ) : this.state.assetDetails.owner_account?.toLowerCase() ==
                    this.state.account?.toLowerCase() ? (
                    <>
                      <Link
                        className="button button__small margin-right"
                        to={"../EditItem/?asset_id=" + this.state.id}
                      >
                        {/* <img src="../images/svg/edit.svg" alt="" /> */}
                        Edit Item{" "}
                      </Link>
                      <Link
                        className="button button__small"
                        to={"../Nftlist/?asset_id=" + this.state.id}
                      >
                        {/* <img src="../images/svg/edit.svg" alt="" /> */}
                        List Item
                      </Link>
                    </>
                  ) : (
                    <></>
                  )}
                </div>

                <h2>{this.state.assetDetails.asset_name}</h2>
                <div className="info-ctrl">
                  Views: {this.state.assetDetails.total_views}
                </div>

                {/* {this.state.isOwnAccount && this.state.account ? ( */}
                {/* <Link
                  className="button button__small"
                  to={"../EditItem/?asset_id=" + this.state.id}
                >
                  <img src="../images/svg/edit.svg" alt="" />
                  &nbsp; Edit Item{" "}
                </Link> */}
                {/* ) : (
                        <></>
                      )}  */}
                <ul className="info-share">
                  {/* <li>
                    <a href="/">
                      <i className="material-icons-outlined">favorite_border</i>
                    </a>
                  </li> */}
                  {/* <li>
                    <a href="/">
                      <i className="material-icons-outlined">open_in_new</i>
                    </a>
                  </li> */}
                  <li>
                    {/* <Link to="">
                      <i className="material-icons-outlined" onMouseEnter
                      ={() => this.onhover()}>share</i>
                    </Link> */}
                    <div>
                      <InlineShareButtons
                        config={{
                          alignment: "center", // alignment of buttons (left, center, right)
                          color: "social", // set the color of buttons (social, white)
                          enabled: true, // show/hide buttons (true, false)
                          font_size: 16, // font size for the buttons
                          labels: "null", // button labels (cta, counts, null)
                          language: "en", // which language to use (see LANGUAGES)
                          networks: [
                            // which networks to include (see SHARING NETWORKS)
                            "whatsapp",
                            "linkedin",
                            "facebook",
                            "twitter",
                            "messenger",
                          ],
                          padding: 12, // padding within buttons (INTEGER)
                          radius: 4, // the corner radius on each button (INTEGER)
                          //show_total: true,
                          size: 40, // the size of each button (INTEGER)

                          // OPTIONAL PARAMETERS
                          url: window.location.href, // (defaults to current url)
                          image: this.state.assetDetails.asset_image, // (defaults to og:image or twitter:image)
                          description: this.state.assetDetails.collection_name, // (defaults to og:description or twitter:description)
                          title: this.state.assetDetails.asset_name, // (defaults to og:title or twitter:title)
                          message: "custom email text", // (only for email sharing)
                          subject: "custom email subject", // (only for email sharing)
                          username: "custom twitter handle", // (only for twitter sharing)
                        }}
                      />
                    </div>
                  </li>
                  {/* <li>
                    <a href="/">
                      <i className="material-icons-outlined">assistant_photo</i>
                    </a>
                  </li> */}
                </ul>
              </div>
              {this.state.assetDetails.price ? (
                <div className="nft-details__info-bid">
                  <span>Top bid</span>
                  <div className="price">
                    <img
                      src={this.state.assetDetails.currency_image}
                      alt="eth"
                    />{" "}
                    {this.state.assetDetails.price}
                    {this.state.assetDetails.usd_amount ? (
                      <small>
                        ${this.state.assetDetails.usd_amount.toFixed(2)}
                      </small>
                    ) : (
                      <></>
                    )}
                  </div>
                  <button className="button btn-place-bid">Place Bid</button>
                  {
                    this.state.addToCartButton ? 
                    <button className="button purple-outline" style={{ display: this.state.sameAccount ? "none" : "inline-block" }} onClick={() => this.addToCart(this.state.assetDetails.asset_id)}>Add To Cart</button>
                    :
                    <button className="button purple-outline" style={{ display: this.state.sameAccount ? "none" : "inline-block" }} onClick={() => this.removeCart()}>Remove From Cart</button>
                  }
                </div> 
              ) : (
                <></>
              )}
              <div className="nft-details__info-bid">
                <span>Details</span>
                <div class="leftDiv">
                  <ul>
                    <li>Contract Address</li>
                    <li>Token ID</li>
                    <li>Token Standard</li>
                    <li>Blockchain</li>
                  </ul>
                </div>
                <div class="rightDiv">
                  <ul>
                    <li className="details">
                      <a
                        href={this.getMarketAddress()}
                        target="_blank"
                        className="link"
                      >
                        {this.state.chainConfig?.NFT_MARKETPLACE_ADDRESS}
                      </a>
                    </li>
                    <li>{this.state.assetDetails.token_id}</li>
                    <li>ERC-721</li>
                    <li>{this.state.chainConfig?.CHAIN_NAME}</li>
                  </ul>
                </div>
              </div>
              <div className="nft-details__info-author">
                <div className="nft-details__info-author-header">
                  <div className="img">
                    <img
                      src={
                        this.state.assetDetails.creator_profile_image
                          ? this.state.assetDetails.creator_profile_image
                          : "../images/default_image.png"
                      }
                      alt="Artist1"
                    />
                  </div>
                  <div className="name">
                    <span>Creator</span>
                    <div>
                      <Link
                        className="link font-size-18"
                        to={
                          "../UserProfile/?account=" +
                          this.state.assetDetails.account
                        }
                      >
                        {this.state.assetDetails.creator_name
                          ? this.state.assetDetails.creator_name
                          : "Unnamed"}
                      </Link>
                      {this.state.assetDetails.isVerified ? (
                        <img
                          src="../images/svg/checked-badge.svg"
                          alt="badge"
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
                <p>{this.state.assetDetails.asset_description}</p>
              </div>
            </div>

            <div className="nft-details__price-graph">
              <div className="nft-details__activity-header">
                <h6>Activity</h6>
              </div>

              {!this.state.loader2 ? (
              <div className="nft-details__activity-table">
                <Scrollbars className="custmScrollbar scrollbar-horizontal">
                  <table width="100%" cellSpacing="7px" cellPadding="0">
                    <thead>
                      <tr>
                        <th>Event</th>
                        <th>Price</th>
                        <th>From</th>
                        <th>To</th>
                        <th>Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.assetActivity.map((activity, index) => (
                        <tr key={index}>
                          <td>
                            <i className="material-icons-outlined">
                              {this.getIcon(activity.event_type)}
                            </i>
                            {"  "}
                            {activity.event_type}
                          </td>
                          <td>
                            {activity.price ? (
                              <img
                                className="prc"
                                src={this.state.assetDetails.currency_image}
                                alt="eth"
                              />
                            ) : (
                              <></>
                            )}
                            {activity.price}
                          </td>
                          <td>
                            {activity.event_type == "Minted" ? (
                              <a
                                href={this.getMarketAddress()}
                                target="_blank"
                                className="link"
                              >
                                {"RedShilliz"}
                              </a>
                            ) : (
                              <Link
                                to={
                                  "../UserProfile/?account=" +
                                  activity.from_owner_account
                                }
                                className="link"
                              >
                                {activity.from_owner
                                  ? activity.from_owner
                                  : "Unnamed"}
                              </Link>
                            )}
                          </td>
                          <td>
                            <Link
                              to={
                                "../UserProfile/?account=" +
                                activity.to_owner_account
                              }
                              className="link"
                            >
                              {activity.to_owner
                                ? activity.to_owner
                                : activity.event_type == "Minted"
                                ? "Unnamed"
                                : ""}
                            </Link>
                          </td>
                          <td>
                            {activity.event_type !== "List" ? (
                              <a
                                target="_blank"
                                href={this.getTransactionLink(
                                  activity.transaction_hash
                                )}
                                className="link"
                              >
                                {this.getFormattedDateTime(activity.time)}
                                {"  "}
                                <i className="material-icons-outlined blue-outline">
                                  open_in_new
                                </i>
                              </a>
                            ) : (
                              this.getFormattedDateTime(activity.time)
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Scrollbars>
              </div>
                ) : (
                  [...Array(5)].map((e, i) => (
                      <Row/>
                  ))
                )}
            </div>
          </div>
        </div>
        <section className="related-nft">
          <div className="exploreCollections">
            <div className="container filter-list-box-wrap">
              <div className="section-title">
                <h2>Related NFTs</h2>
              </div>
              {!this.state.loader ? (
                <ul className="explore-nfts">
                  {this.state.relatedAssets.map((relatedasset, index) => (
                    <li key={index} onClick={() => this.initFunction()}>
                      <Link
                        to={"../NftDetails/?assetId=" + relatedasset.asset_id}
                        className="card"
                        onClick={() => this.scrollToTestDiv()}
                      >
                        <div className="card-img">
                          <img src={relatedasset.asset_image} alt="discover" />
                          {relatedasset.price ? (
                            <div className="price">
                              <img src="../images/eth.png" alt="price" />{" "}
                              {relatedasset.price}
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                        <div className="card-body">
                          <div className="artist-block">
                            <div className="media">
                              <div className="media-img">
                                <img
                                  src={
                                    relatedasset.profile_image
                                      ? relatedasset.profile_image
                                      : "../images/default_image.png"
                                  }
                                  alt="artist block"
                                />
                              </div>
                              <div className="media-body">
                                <h4 title={relatedasset.asset_name}>
                                  <label
                                    style={{
                                      width: 120 + "px",
                                      color: "#ffffff",
                                      whiteSpace: "nowrap",
                                      overflow: " hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    {relatedasset.asset_name}
                                  </label>
                                  {/* <div className="img-box">
                                  {relatedasset.is_verified ? (
                                    <img
                                      src="../images/verify.png"
                                      alt="verify"
                                    />
                                  ) : (
                                    ""
                                  )}
                                </div> */}
                                </h4>
                                <span>{relatedasset.user_name}</span>
                              </div>
                              {/* <div className="bid-count">1 of 10</div> */}
                            </div>
                          </div>
                        </div>
                      </Link>
                    </li>
                  ))}
                  {/* LI END */}
                </ul>
              ) : (
                [1, 2, 3, 4, 5, 6, 7, 8].map((loading) => (
                  <>
                    <div className="skeleton-items" key={loading}>
                      <SkeletonProduct />
                    </div>
                  </>
                ))
              )}
              {/* <div style={{ display: this.state.relatedAssets.length==0 ? "none" : "block" }}>
              <div className="button-wrap">
                <a  className="button purple-outline"
                onClick={() => this.showMore()}>
                  Show More
                </a>
              </div>
              </div> */}
            </div>
          </div>
        </section>
        <Footer />
      </>
    );
  };
}

// export default NftDetails;
